import { MarketingButtons } from "../../components/MarketingButtons";
import { PageContent } from "../../pages/templates/PageLayout";
import { exampleLinks } from "./exampleLinks";
import featureCards from "../featureCards";
import Images from "../images";

const data: PageContent = {
  style: "light",
  sections: [
    {
      type: "HeroSection",
      title: "Digital asset management",
      subtitle: `Easily store, organize and share all your digital assets, so you can empower your team to create on their own while ensuring consistency at scale.  [See an example.](${exampleLinks.digitalAssetManagement})`,
      primaryButton: MarketingButtons.getStarted,
      secondaryButton: MarketingButtons.bookDemo,
      image: {
        src: Images.Solutions.DAM_hero,
        alt: "Brand guidelines",
      },
    },
    {
      type: "MediaSection",
      title: "All your assets in one place",
      subtitle:
        "Product shots, editorial photos, and every other content type you can think of in a single place.",
      layoutDirection: "image-left",
      body: {
        style: "tabList",
        items: [
          {
            title: "Visually browsable",
            body: "Stop wasting time diving through complicated folder trees. In Lingo all your assets are visible and easy to locate within Lingo’s gallery.",
            image: {
              src: Images.Solutions.DAM_visuallyBrowse,
              alt: "Content and Context. Together.",
            },
          },
          {
            title: "Stay organized with custom metadata",
            body: "Custom fields and tags make your assets easier to organize, find and manage.",
            image: {
              src: Images.Solutions.DAM_customMetadata,
              alt: "Advanced custom branding",
            },
          },
          {
            title: "No breaking the bank",
            body: "Save your budget to create that next great experience. Why can’t digital asset managers be DAM affordable after all?",
            image: {
              src: Images.Solutions.DAM_affordable,
              alt: "No breaking the bank",
            },
          },
          {
            title: "Self-serve",
            body: "Empower your team to find the assets they need in the format they need all on their own.",
            image: {
              src: Images.Solutions.DAM_selfServe,
              alt: "Self serve assets",
            },
          },
        ],
      },
    },
    {
      type: "CardSection",
      title: "More powerful features to manage your assets",
      footerButton: {
        link: "/product/features",
        text: "View all features",
        buttonStyle: "outline",
      },
      items: [
        featureCards.search,
        featureCards.unlimitedKits,
        featureCards.insights,
        featureCards.integrations,
        featureCards.customFields,
        featureCards.fileConversions,
      ],
    },
    {
      type: "FaqSection",
      title: "Frequently asked questions",
      faqs: [
        {
          question: "How is Lingo’s DAM different from Google Drive or Dropbox?",
          answer:
            "Unlike traditional cloud storage, Lingo is built for brand asset management. It provides a structured, searchable hub with metadata tagging, visual previews, and built-in brand guidelines so teams can easily find and use the right assets without the clutter of generic file storage.",
        },
        {
          question: "Can Lingo’s DAM help maintain brand consistency?",
          answer:
            "Absolutely! Lingo connects brand guidelines with assets, ensuring teams always use the latest, approved files with clear usage instructions. No more outdated logos or off-brand materials slipping through the cracks.",
        },
        {
          question: "How does Lingo make finding assets easier?",
          answer:
            "Lingo organizes assets into structured kits with metadata tagging, custom tagging, visual search, and intuitive filters. No more digging through endless folders — your teams can locate what they need in seconds.",
        },
        {
          question: "Is Lingo’s DAM complicated to set up?",
          answer:
            "Not at all! Unlike traditional DAMs that require extensive setup, Lingo is designed to be lightweight and flexible. You can easily upload assets, organize them into kits or transfer them directly from Google Drive or Dropbox with our integrations. Either way, start sharing immediately without IT headaches to set it up!",
        },
        {
          question: "Can I control who has access to specific assets?",
          answer:
            "Yes! Lingo offers customizable permissions, public and private kits, password protection, and download tracking to ensure only the right people access the right content.",
        },
        {
          question: "Does Lingo integrate with the tools we already use?",
          answer:
            "Yes! Lingo integrates with tools like Canva, Google Drive, and Dropbox, allowing seamless asset updates and easy collaboration across platforms.",
        },
        {
          question: "How does Lingo ensure our team always has the latest versions of assets?",
          answer:
            "Lingo’s version control keeps assets up to date automatically. When a file is updated, it syncs across your kits so teams always have the most current version without hunting for updates.",
        },
      ],
    },
    { type: "CtaSection" },
  ],
};

export default data;
